<template>
  <div>
    <h1>
      {{ $t("chapter.infoPopup.infoPopupContents") }}
    </h1>
    <v-expansion-panels :value="0">
      <v-expansion-panel>
        <v-expansion-panel-header
          >{{ $t("chapter.infoPopup.popupSettings") }}
        </v-expansion-panel-header>
        <v-expansion-panel-content style="text-align: left" v-if="editor">
          <InfoMediaUpload
            :editor="editor"
          />
          {{ $t("chapter.infoPopup.textBlock") }}
          <v-textarea
            v-model="info"
            outlined
            :counter="maxLengthCharacters"
            background-color="white"
            @input="updateInfo"
            color="accentElement"
          ></v-textarea>
          <v-btn @click="removePopup">{{
            $t("chapter.infoPopup.remove")
          }}</v-btn>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>
<script>
import InfoMediaUpload from "./InfoMediaUpload";
import debounce from "@/helpers/debounce";
const MAX_LENGTH_CHARACTERS = 180;
export default {
  props: {
    editor: Object,
    infoValue: String,
  },
  components: {
    InfoMediaUpload,
  },
  data() {
    return {
      info: this.infoValue ? this.infoValue : "",
    };
  },
  methods: {
    updateInfo: debounce(async function () {
      this.editor
        .chain()
        .setInfoValue(this.info.slice(0, MAX_LENGTH_CHARACTERS))
        .run();
    }, 500),
    removePopup() {
      this.editor.chain().focus().unsetInfo().run();
    },
  },
  watch: {
    infoValue(newValue) {
      if (this.info != newValue) {
        this.info = newValue;
      }
    },
  },
  computed: {
    maxLengthCharacters() {
      return MAX_LENGTH_CHARACTERS;
    },
  },
};
</script>